let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cPBh9")).then(() => parcelRequire('lAHXi'));